import React, { useEffect, useState } from "react";

import { Stack } from "@mui/material";
import { RoleComponentGuard } from "components";
import { Activity, AIBox, DealHierarchy, Graph, KPIs, SubDealsCard, Tasks } from "components/Deal-dashboard";
import OverviewCard from "components/Deal-dashboard/OverviewCard";
import {
  useAccountSelector,
  useDealSubAssetsSelector,
  useDealTypeSelect,
  useParentDealSelect,
  usePickUserPermissions,
  useViewActions
} from "store";
import { DateRangeValue, UserPermissionType } from "store/types";

import { RoleName } from "../../constants";

interface Props {}

export const DealDashboard: React.FC<Props> = () => {
  const portfolioAnalysis = usePickUserPermissions("portfolio_analysis");
  const noAccessPermission = portfolioAnalysis && portfolioAnalysis === UserPermissionType.NO_ACCESS;
  const subDeals = useDealSubAssetsSelector();
  const parentDeal = useParentDealSelect();
  const dealType = useDealTypeSelect();
  const { show_debt } = useAccountSelector() || {};
  const { setIsDealCharBarOpenAction } = useViewActions();
  const [dateRange, setDateRange] = useState<DateRangeValue<string>>({
    value: "fromInception",
    to: new Date().toISOString()
  });

  useEffect(() => {
    setIsDealCharBarOpenAction(true);
  }, []);

  return (
    <Stack sx={{ gap: "16px", overflow: "auto", overflowX: "hidden" }}>
      <RoleComponentGuard
        availableRoles={[RoleName.Admin, RoleName.Analyst, RoleName.TeamViewer, RoleName.Investor]}
        hideChild={noAccessPermission}
      >
        <KPIs dateRange={dateRange} setDateRange={setDateRange} />
      </RoleComponentGuard>
      {show_debt && <AIBox />}
      {dealType === "debt" ? (
        <Stack
          direction="row"
          sx={{ gap: "20px", overflow: "hidden", maxHeight: "494px", minHeight: "200px", p: "1px" }}
        >
          <OverviewCard />
          <SubDealsCard toDate={(dateRange.to || new Date().toISOString()).split("T")[0]} />
        </Stack>
      ) : (
        <Stack direction="row" sx={{ gap: "20px" }}>
          <RoleComponentGuard
            availableRoles={[RoleName.Admin, RoleName.Analyst, RoleName.TeamViewer]}
            hideChild={noAccessPermission}
          >
            <Graph />
          </RoleComponentGuard>
          <Stack sx={{ maxWidth: 402, minWidth: 402, flexShrink: 0 }}>
            <Tasks />
          </Stack>
        </Stack>
      )}
      <Stack direction="row" sx={{ gap: "20px", overflow: "hidden", p: "1px", minHeight: "270px" }}>
        <Activity />
        {dealType === "debt" && <Tasks />}
        {parentDeal && !!subDeals.length && (
          <Stack sx={{ maxWidth: 402, minWidth: 402, flexShrink: 0 }}>
            <DealHierarchy />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
